import { useState, useRef } from 'react';

export const TESTO_INVIA = 'Invia a competenze';
export const TESTO_GIA_INVIATA = 'Già inviata a Competenze. Per rinviarla, elimina la riga in Competenze';

// Bottone rotondo "€" nella colonna Azioni dello Scadenziario.
// Il tooltip è posizionato con coordinate dello schermo (position: fixed): il contenitore della tabella scorre in
// orizzontale e taglierebbe un tooltip normale. Resta raggiungibile da tastiera anche quando la riga è già inviata.
export default function BottoneInvio({ inviata, occupato, onInvia }) {
  const [tip, setTip] = useState(null);
  const rif = useRef(null);
  const testo = inviata ? TESTO_GIA_INVIATA : TESTO_INVIA;

  const mostra = () => {
    const r = rif.current?.getBoundingClientRect();
    if (!r) return;
    const larghezza = 230;
    const x = Math.max(8, Math.min(r.right - larghezza, window.innerWidth - larghezza - 8));
    setTip({ x, y: r.top - 8, sopra: r.top > 70, giu: r.bottom + 8 });
  };

  return (
    <>
      <button
        ref={rif}
        type="button"
        className={`bottoneInvio ${inviata ? 'bottoneInvioInviata' : ''}`}
        aria-label={testo}
        aria-disabled={inviata || occupato ? 'true' : undefined}
        onClick={() => { if (!inviata && !occupato) onInvia(); }}
        onMouseEnter={mostra}
        onMouseLeave={() => setTip(null)}
        onFocus={mostra}
        onBlur={() => setTip(null)}
      >€</button>
      {tip && (
        <span role="tooltip" className="bottoneInvioTip"
          style={{ left: tip.x, top: tip.sopra ? tip.y : tip.giu, transform: tip.sopra ? 'translateY(-100%)' : 'none', width: 230 }}>
          {testo}
        </span>
      )}
    </>
  );
}
